import { Vector3 } from '@babylonjs/core';
import { Button, Control } from '@babylonjs/gui';
import { Game } from './Game';
import { GameState } from './GameState';
import { Gui } from './gui/Gui';

export class GameFinish {
  constructor(public game: Game) {}

  async create() {
    await Gui.createDefaultScene(
      this.game,
      {
        url: 'assets/skybox/abstract_green_bubbles.jpg',
        rotationAxis: 'y',
      },
      'You made it!\nThanks for playing!'
    );
    await this.game.sound.createBackgroundMusic('superboy');
    await Gui.createAnimatedPlayer(this.game, 'Capoeira', new Vector3(6, 2, 0), true);

    const thanksText = `
    Writing a jump and run game was one of my childhood dreams and I'm really thankful it finally worked out, in a way...
    I want to thank my family for their support and patience for the months it took me to create this game.
    I hope you had as much fun playing it as I had creating it!

    Thanks to the creators of Babylon.js for the amazing framework!
    Thanks to Kenney for the amazing assets!
    Thanks to the creators on itch.io for their amazing sounds and models!
    Thanks to Claude AI for helping me fix my bugs!
    Thanks to Mixamo for their phenomenal animations!
    `;
    const thanks = this.game.gui2D.createTextBlock('thanks', thanksText, this.game.gui2D.ui.rootContainer, Gui.fontSizeXS);
    thanks.textHorizontalAlignment = Control.HORIZONTAL_ALIGNMENT_CENTER;
    thanks.textVerticalAlignment = Control.VERTICAL_ALIGNMENT_CENTER;

    thanks.top = '5%';
    thanks.width = '80%';
    await GameFinish.createRestartButton(this.game);
  }

  static restartGame(game: Game) {
    game.sound.play('click');
    game.routeTo(GameState.MAIN);
  }

  static async createRestartButton(game: Game): Promise<Button> {
    const button = game.gui2D.createButton(
      'button_restart',
      '🖥️ Restart',
      () => {
        GameFinish.restartGame(game);
      },
      game.gui2D.ui.rootContainer,
      1,
      game.gui2D.sceneButtonColors()
    );
    game.gui2D.styleSceneButton(button);
    button.top = '35%';
    return button;
  }
}
